module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_03-42a77e56626c861921284aec8ea95bb5.jpg";